import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Question } from '../../data/questions';
interface QuestionCardProps {
  question: Question;
  index: number;
  answer: boolean | null;
  onAnswer: (index: number, value: boolean) => void;
}
export function QuestionCard({
  question,
  index,
  answer,
  onAnswer
}: QuestionCardProps) {
  const isAnswered = answer !== null;
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className={`bg-[#0d0d0d] border rounded-xl p-6 md:p-8 mb-5 transition-colors duration-300 ${isAnswered ? 'border-[var(--gold)]' : 'border-[#1a1a1a]'}`} data-id="element-44">
      <div className="inline-block px-3 py-1 rounded text-[10px] font-bold tracking-[1px] mb-4 text-white uppercase" style={{
      backgroundColor: question.tagClass
    }} data-id="element-45">
        {question.tag} — {question.area}
      </div>
      <div className="text-[15px] leading-[1.5] text-white mb-5 flex items-start" data-id="element-46">
        <span className="inline-flex items-center justify-center w-7 h-7 bg-[var(--navy)] text-white rounded-full text-xs font-bold mr-3 shrink-0" data-id="element-47">
          {index + 1}
        </span>
        <span className="pt-0.5" data-id="element-48">{question.q}</span>
      </div>
      <div className="flex gap-3" data-id="element-49">
        <button onClick={() => onAnswer(index, true)} className={`flex-1 py-3.5 px-4 border-2 text-sm font-bold rounded-lg cursor-pointer tracking-[1px] transition-all duration-300 ${answer === true ? 'bg-[var(--green)] border-[var(--green)] text-white' : 'bg-transparent border-[#333333] text-white hover:border-[var(--gold)]'}`} data-id="element-50">
          SÍ
        </button>
        <button onClick={() => onAnswer(index, false)} className={`flex-1 py-3.5 px-4 border-2 text-sm font-bold rounded-lg cursor-pointer tracking-[1px] transition-all duration-300 ${answer === false ? 'bg-[var(--red)] border-[var(--red)] text-white' : 'bg-transparent border-[#333333] text-white hover:border-[var(--gold)]'}`} data-id="element-51">
          NO
        </button>
      </div>
      <AnimatePresence data-id="element-52">
        {isAnswered && <motion.div initial={{
        opacity: 0,
        height: 0,
        marginTop: 0
      }} animate={{
        opacity: 1,
        height: 'auto',
        marginTop: 12
      }} className={`text-xs p-3 rounded-md leading-[1.4] ${answer === true ? 'bg-[rgba(39,174,96,0.1)] text-[var(--green)] border-l-4 border-[var(--green)]' : 'bg-[rgba(192,57,43,0.1)] text-[var(--red)] border-l-4 border-[var(--red)]'}`} data-id="element-53">
            {answer === true ? question.si : question.no}
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}